import { compare } from "@thi.ng/compare";
import { $$reduce, reducer } from "../reduce";
export function minCompare(...args) {
    const res = $$reduce(minCompare, args);
    if (res !== undefined) {
        return res;
    }
    const init = args[0];
    const cmp = args[1] || compare;
    return reducer(init, (acc, x) => (cmp(acc, x) <= 0 ? acc : x));
}
